import React from 'react';

import { Game, Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function GameDetailsTable({ gameData }: { gameData: any }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        text: 'Provider',
      },
      value: {
        text: `${gameData?.originalProviderId}`,
      },
    },
    {
      label: {
        text: 'Game ID',
      },
      value: {
        text: gameData?.gameId || 0,
      },
    },
    {
      label: {
        text: 'RTP',
      },
      value: {
        text: `${gameData?.rtp}%`,
      },
    },
    {
      label: {
        text: 'Categories',
      },
      value: {
        text: gameData?.categories?.['en']?.join(','),
      },
    },
  ];

  return <HorizontalTable header="Game Details" status={gameData.status} tableData={tableData} />;
}
